class FileUploadQueue {
    constructor() {
        this.queuedUploads = [];
    }
    
    enqueue(fileObject) {
        this.queuedUploads.push(fileObject);
        return true;
    }
    
    isEmpty() {
        return this.queuedUploads.length === 0;
    }
    
    peek() {
        return this.queuedUploads[0];
    }
    
    dequeue() {
        return this.queuedUploads.shift();
    }
}

export default FileUploadQueue;